import axios from "./_axios";
import { API } from "./apiEndPoints";
import { invalidateAccountDetails } from "./appsAPI";

export const requestAccountLogoUpload = (account_id, { file_name, content_type, size }) => {
  return axios()({
    method: "post",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/logo/upload/`,
    data: { file_name, content_type, size },
  });
};

// Bytes go straight to storage: no app token, and the Content-Type must equal the one that was signed.
export const putAccountLogoToStorage = (upload_url, file, content_type) => {
  return axios(false)({
    method: "put",
    url: upload_url,
    data: file,
    headers: { "Content-Type": content_type },
  });
};

export const completeAccountLogoUpload = async (account_id, media_id) => {
  try {
    return await axios()({
      method: "post",
      url: `${API.ACCOUNT_LIST_V2}${account_id}/logo/`,
      data: { media_id },
    });
  } finally {
    invalidateAccountDetails();
  }
};

export const deleteAccountLogo = async (account_id) => {
  try {
    return await axios()({
      method: "delete",
      url: `${API.ACCOUNT_LIST_V2}${account_id}/logo/`,
    });
  } finally {
    invalidateAccountDetails();
  }
};

/**
 * Upload (or replace) the account logo: mint the presigned URL, PUT the file, then complete.
 * Resolves with the new public `logo_url`.
 */
export const uploadAccountLogo = async (account_id, file) => {
  const content_type = file.type;
  const { data: upload } = await requestAccountLogoUpload(account_id, {
    file_name: file.name,
    content_type,
    size: file.size,
  });
  await putAccountLogoToStorage(upload.upload_url, file, upload.content_type || content_type);
  const { data } = await completeAccountLogoUpload(account_id, upload.media_id);
  return data.logo_url;
};
